type FontFallback = {
  className: string
  variable: string
  style: {
    fontFamily: string
  }
}

const createFontFallback = (className: string, fontFamily: string): FontFallback => ({
  className,
  variable: '',
  style: {
    fontFamily,
  },
})

export const Inter = (..._args: unknown[]): FontFallback =>
  createFontFallback(
    'font-inter-fallback',
    'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
  )

/** NINGENIE / NINX logo wordmark: pairs with Montserrat Subrayada in globals.css @import */
export const Montserrat_Underline = (..._args: unknown[]): FontFallback =>
  createFontFallback(
    'font-montserrat-subrayada',
    '"Montserrat Subrayada", "Montserrat Underline", Inter, ui-sans-serif, system-ui, sans-serif'
  )

export const Permanent_Marker = (..._args: unknown[]): FontFallback =>
  createFontFallback('font-permanent-marker', '"Permanent Marker", cursive')

/** 8-bit / pixel UI. NINXL landing */
export const Press_Start_2P = (..._args: unknown[]): FontFallback =>
  createFontFallback(
    'font-press-start-2p',
    '"Press Start 2P", "Courier New", Courier, monospace'
  )

export const VT323 = (..._args: unknown[]): FontFallback =>
  createFontFallback('font-vt323', 'VT323, "Courier New", Courier, monospace')
